import ApiClient from '../ApiClient';

class MessageReports extends ApiClient {
  constructor() {
    super('my_ai/message_reports', { accountScoped: true });
  }
}

export default new MessageReports();
